import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/Middle_Ages_-_Mongol_Empire.png';

function HistoryPageMongols() {
  return (
    <TopicPage
      topicKey="Mongol Empire"
      title="History: Mongol Empire"
      backgroundImage={bg}
      startRoute="/History-Mongol-Empire-Go"
      scrollLabels={[
        "Genghis Khan and Expansion",
        "Trade and Tolerance",
        "Legacy and Decline",
      ]}
                    backRoute="/history-Middle-Ages"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageMongols;   